function OwnerName({name}){
  return(
    <div className="details-owner-name">
      {name}
    </div>
  );
}

export default OwnerName;
